module.exports = __webpack_public_path__ + "static/media/people-fill.5b18e210.svg";